export default __webpack_public_path__ + "static/media/zucchero_main.c563d82b.webp";